var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangePlanModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Message/ChangePlan") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Message/ChangePlan",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-change-plan"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.39,80.87 L11.42,80.87 C6.62,80.87 2.73,76.81 2.73,71.8 L2.73,20.1 C2.73,15.09 6.62,11.03 11.42,11.03 L98.34,11.03 C103.14,11.03 107.03,15.09 107.03,20.1 L107.03,63.12",
    id: "Path",
    stroke: "#282828",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#282828",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 29.02,
    cy: 37.39,
    r: 7.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.38,57.24 L16.65,57.24 C16.65,50.41 22.18,44.88 29.01,44.88 C35.84,44.88 41.37,50.41 41.37,57.24 L41.38,57.24 Z",
    id: "Path",
    stroke: "#282828",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.04,
    y1: 35.83,
    x2: 80.32,
    y2: 35.83,
    id: "Path",
    stroke: "#282828",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.04,
    y1: 44.22,
    x2: 80.32,
    y2: 44.22,
    id: "Path",
    stroke: "#282828",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.04,
    y1: 53.35,
    x2: 80.32,
    y2: 53.35,
    id: "Path",
    stroke: "#282828",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#282828",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 91.83,
    cy: 83.53,
    r: 25.44
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(73.750000, 70.284977)",
    stroke: "#FF7900",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.43,0.465023189 C17.18,-0.604976811 12.99,0.135023189 9.92,3.06502319 C7.09,5.76502319 5.23,9.05502319 4.89,15.2250232"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "0 13.3350232 4.94 18.3350232 9.83 13.2850232"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.730000, 8.215023)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.42108547e-14,17.87 C3.81,18.77 8.44,18.2 11.51,15.27 C14.34,12.57 16.2,9.28 16.54,3.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "21.43 5.01 16.49 0 11.59 5.05"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePlanModal);
export default __webpack_public_path__ + "static/media/change_plan_modal.c55a4528e67ee3ffed5f7ec8ba04b684.svg";
export { ForwardRef as ReactComponent };